import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { searchTask } from "../features/tasks/tasksSlice";
import logo from "../images/logo.svg";

const Navbar = () => {
  const dispatch = useDispatch();
  const debounceHandler = (fn, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fn(...args);
      }, delay);
    };
  };

  const doSearch = (value) => {
    dispatch(searchTask(value));
  };

  const handleSearch = debounceHandler(doSearch, 300);

  return (
    <nav className="container relative py-3">
      <div className="flex items-center justify-between">
        <Link to="/">
          <img src={logo} alt="Lws" />
        </Link>
        <div className="flex-1 max-w-xs search-field group">
          <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500" />
          <input
            type="text"
            placeholder="Search Task"
            className="search-input"
            id="lws-searchTask"
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
